@let ast = asset();

@switch (mode()) {
  @case ('thumbnail') {
    <img [src]="getUrl()" [alt]="ast.displayName" class="img-fluid w-100"/>
  }
  @case ('view') {
    <img [src]="getUrl()" [alt]="ast.displayName" class="img-fluid w-100"/>
  }
  @case ('details') {
    <dl>
      <div class="row">
        <dt>MIME:</dt>
        <dd>{{ ast.mimeType ?? 'N/A' }}</dd>
      </div>
      <div class="row">
        <dt>Description:</dt>
        <dd>{{ ast.description }}</dd>
      </div>
    </dl>
  }
}
